export default __webpack_public_path__ + "static/media/1812.376064a1.png";